import Vue from 'vue'
import App from './App'
import VueClipboard from 'vue-clipboard2'

// import 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900'
import '@mdi/font/css/materialdesignicons.css'
import "vue-material-design-icons/styles.css"
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import './config/msgs'
import './config/axios'
import './config/mq'

import moment from 'moment-timezone'
moment.tz.setDefault('America/Campo_Grande')  

import router from './config/router'
import store from './store/store'
import MultiFiltersPlugin from './plugins/MultiFilters' 
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

Vue.use(MultiFiltersPlugin)
Vue.use(VueClipboard)

Vue.filter('date', (value) => {
  if (!value) return null
  return moment(value).format("DD/MM/YYYY")
})
Vue.filter('dateYear', (value) => {
  if (!value) return null
  return moment(value).format("YYYY")
})
Vue.filter('datePlusWeek', (value) => {
  if (!value) return null
  return moment(value).format("DD/MM/YYYY, dddd")
})
Vue.filter('hour', (value) => {
  if (!value) return null
  return moment(value).format("HH")
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')